import { render, staticRenderFns } from "./notification-ticket-analyst.vue?vue&type=template&id=41cdd448&scoped=true"
import script from "./notification-ticket-analyst.vue?vue&type=script&lang=js"
export * from "./notification-ticket-analyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cdd448",
  null
  
)

export default component.exports